import { useLocation, Link } from "react-router-dom";
import SEO from "../components/common/SEO";
import PageHero from "../components/common/PageHero";

const CONTENT = {
  "/privacy": {
    title: "Privacy Policy",
    intro: "This is placeholder privacy content that AMVI administrators can replace with their finalized policy.",
  },
  "/terms": {
    title: "Terms of Use",
    intro: "This is placeholder terms content that AMVI administrators can replace with their finalized terms.",
  },
  "/cookies": {
    title: "Cookie Policy",
    intro: "This is placeholder cookie content that AMVI administrators can replace with their finalized policy.",
  },
};

export default function Legal() {
  const { pathname } = useLocation();
  const c = CONTENT[pathname] || CONTENT["/privacy"];
  return (
    <>
      <SEO title={c.title} path={pathname} />
      <PageHero eyebrow="Legal" title={c.title} subtitle={c.intro} />
      <section className="px-6 pb-24">
        <div className="mx-auto max-w-3xl space-y-6 text-base leading-relaxed text-slate-400">
          <p>
            AMVI Technologies is committed to protecting your information and being transparent
            about how we operate. This page is an editable placeholder and should be replaced with
            the company's finalized legal language.
          </p>
          <p>
            For any questions related to this policy, please <Link to="/contact" className="text-sky-400 hover:underline">contact us</Link>.
          </p>
        </div>
      </section>
    </>
  );
}
